import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { ServiceCookies } from '@services/ServiceCookies';
import { getPriceForRegion, getTextProduct, getTextBasket } from './getTextMessage';
import { infoMessageActions } from '../../module/slice/infoMessageSlice';
import { Messages } from '../../module/types/infoMessageSchema';
import { getProductPrice } from '@entities/Product';
import { hideRegion } from '@entities/infoMessages/ui/YellowSlots/config';
import { Button, ButtonThemes, Modal } from '@app/shared';
import { InfoWhite, IconCrown } from '@koleso-icons';
import { isShowForThisPage } from './isShowForThisPage';
import { ModalStory } from './Modal';
import config from '@app/config';
import classNames from 'classnames';

import IconClose from './icons/close.svg';

import styles from './YellowSlots.module.scss';

const YellowSlots = () => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { REGION: regionId } = useAppSelector(state => state.header.data.region);
  const { MessageYellowSlot } = useAppSelector(state => state.infoMessage);
  const { regionPartner } = useAppSelector(state => state.header.data);
  const price = useAppSelector(getProductPrice);
  const minPriceShow = getPriceForRegion(Number(regionId));

  useEffect(() => {
    if (ServiceCookies.get(ServiceCookies.YELLOW_SLOTS_BANNER) === 'hide') {
      dispatch(infoMessageActions.messageHide(Messages.MessageYellowSlot));
    } else {
      dispatch(infoMessageActions.messageShow(Messages.MessageYellowSlot));
    }
  }, []);

  const handlerClose = async () => {
    const timeCookies = new Date(new Date().getTime() + ServiceCookies.YELLOW_SLOTS_TIME);
    ServiceCookies.set(ServiceCookies.YELLOW_SLOTS_BANNER, 'hide', {
      path: '/',
      domain: config.baseDomain,
      expires: timeCookies,
    });
    dispatch(infoMessageActions.messageHide(Messages.MessageYellowSlot));
  };

  const handlerOpenModalInfo = () => {
    setIsOpen(true);
  };

  const handlerCloseModalInfo = () => {
    setIsOpen(false);
    handlerClose();
  };

  if (hideRegion.includes(parseInt(regionId))) {
    return null;
  }

  if (MessageYellowSlot && isShowForThisPage(router.route, price, minPriceShow) && !regionPartner && config.isShowYellowSlots) {
    return (
      <>
        <div className={styles.Wrapper}>
          <div className={styles.Container} onClick={handlerOpenModalInfo}>
            <IconCrown className={styles.Crown} width={30} height={30} />
            <div dangerouslySetInnerHTML={{ __html: router.route === '/mycart' ? getTextBasket(+regionId) : getTextProduct() }} />
            <Button themes={ButtonThemes.Clear} className={styles.BtnInfo}>
              <InfoWhite width={16} height={16} />
            </Button>
            <Button themes={ButtonThemes.Clear} className={styles.BtnClose} onClick={handlerClose}>
              <IconClose width={24} height={24} />
            </Button>
          </div>
        </div>
        <YellowSlots.BlockModalStory isOpen={isOpen} minPriceShow={minPriceShow} handleClose={handlerCloseModalInfo} />
      </>
    );
  } else {
    return null;
  }
};

YellowSlots.BlockModalStory = function BlockModalStory({ isOpen, minPriceShow, handleClose }) {
  return (
    <Modal isOpen={isOpen} onClose={handleClose} className={classNames(styles.WrapperStory)} closeOnOverlayClick>
      <ModalStory minPriceShow={minPriceShow} handleClose={handleClose} />
    </Modal>
  );
};

export default YellowSlots;
